import { ArrowUp } from 'lucide-react';
import { useSyncExternalStore } from 'react';
import { prefersReducedMotion } from '@/lib/motion';
import { cn } from '@/lib/utils';

const ScrollThresholdPx = 400;

function subscribeToScroll(onScroll) {
  window.addEventListener('scroll', onScroll, { passive: true });
  return () => window.removeEventListener('scroll', onScroll);
}

function isScrolledPastThreshold() {
  return window.scrollY > ScrollThresholdPx;
}

function isScrolledPastThresholdOnServer() {
  return false;
}

export function ScrollToTopButton() {
  const isVisible = useSyncExternalStore(subscribeToScroll, isScrolledPastThreshold, isScrolledPastThresholdOnServer);

  function handleClick() {
    window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }

  return (
    <button
      type="button"
      aria-label="Scroll to top"
      inert={!isVisible}
      onClick={handleClick}
      className={cn(
        'fixed bottom-6 right-6 z-30 flex size-11 items-center justify-center rounded-full bg-graphite text-paper shadow-md transition-opacity duration-200 hover:bg-graphite-strong focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-graphite sm:bottom-8 sm:right-8',
        isVisible ? 'opacity-100' : 'pointer-events-none opacity-0'
      )}
    >
      <ArrowUp className="size-5" />
    </button>
  );
}